import styled from 'styled-components';

interface EmptyStateProps {
  padding?: string;
  textAlign?: 'left' | 'center' | 'right';
  background?: string;
  borderRadius?: string;
  margin?: string;
}

export const EmptyState = styled.div<EmptyStateProps>`
  text-align: ${props => props.textAlign || 'center'};
  padding: ${props => props.padding || '3rem'};
  color: #64748b;
  background: ${props => props.background || 'transparent'};
  border-radius: ${props => props.borderRadius || '0'};
  margin: ${props => props.margin || '0'};
`;

export const EmptyStateTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  color: #374151;
  font-size: 1.125rem;
  font-weight: 600;
`;

export const EmptyStateText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
`;

// Specialized empty state variants
export const EmptySearchState = styled(EmptyState)`
  padding: 2rem;
  font-style: italic;
`;

export const EmptyStateMessage = styled(EmptyState)`
  background: #f9fafb;
  border-radius: 8px;
  margin: 16px 0;
  padding: 40px 20px;
  font-size: 0.875rem;
`;

export const NoUrlsMessage = styled(EmptyState)`
  font-style: italic;
  padding: 20px;
  font-size: 0.875rem;
`;